const About = () => {
  return (
    <>
      <section className="about" id="About">
        <h4 className="about__text">About Me</h4>
        <p>
          <span className=" font-weight-bold">DOGGED DESIGNS</span> is the name
          of my design and website development brand . <br />
          Welcome to my "About Me" section. I'm thrilled to have this chance to
          introduce myself as a dedicated and dynamic fullstack web developer.
          My journey in web development has been marked by a thirst for
          knowledge and a commitment to continuous growth. <br /> Whether I'm
          refining the user interface to make it intuitive and visually
          engaging, or architecting databases and server systems for optimal
          performance, I approach each challenge with curiosity and
          determination. What sets me apart is not only my technical proficiency
          but also my innate ability to understand and adapt to the
          ever-changing landscape of web technologies. This adaptability,
          coupled with a collaborative mindset, allows me to seamlessly
          integrate within multidisciplinary teams, turning ideas into reality.{" "}
          <br /> Beyond coding, I'm a firm believer in the power of
          communication. I value clear and open dialogue, both with colleagues
          and clients, to ensure that every project reflects their vision and
          meets their needs. This approach has not only produced exceptional
          results but also fostered lasting relationships built on trust and
          mutual understanding. Thank you for taking the time to get to know me
          better. I'm excited about the opportunities that lie ahead and the
          potential to contribute my skills to projects that make a real impact.
          If you're passionate about innovative solutions and seamless user
          experiences, I'm eager to connect and collaborate.
        </p>

        <div className="row">
          <div className="pb-5 col-lg-3 col-sm-12 col-md-3">
            <div className="m-auto p-3 about__font">
              <h4 className="font-weight-bold text-white text-capitalize roboto">
                2018
              </h4>
              <p className="text-secondary rales">started my journey</p>
            </div>
          </div>
          <div className="pb-5 col-lg-3 col-sm-12 col-md-3">
            <div className="m-auto p-3 about__font">
              <h4 className="font-weight-bold text-white text-capitalize roboto">
                2019
              </h4>
              <p className="text-secondary rales">
                front-end javascript mastery
              </p>
            </div>
          </div>
          <div className="pb-5 col-lg-3 col-sm-12 col-md-3">
            <div className="m-auto p-3 about__font">
              <h4 className="font-weight-bold text-white text-capitalize roboto">
                2020
              </h4>
              <p className="text-secondary rales">
                shared my project to the world
              </p>
            </div>
          </div>
          <div className="pb-5 col-lg-2 col-sm-12 col-md-6">
            <div className="m-auto p-3 about__font">
              <h4 className="font-weight-bold text-white text-capitalize roboto">
                2022
              </h4>
              <p className="text-secondary rales">started my own platform</p>
            </div>
          </div>
        </div>
      </section>
      {/* <section classNameName="about">
        <h4 classNameName="about__text">About Me</h4>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
          dolorum architecto facere, sapiente voluptatum eos totam at dicta
          voluptatem? Reprehenderit officiis tempora autem repudiandae similique
          aliquid culpa beatae necessitatibus inventore nesciunt consequuntur
          ipsum, facere dolor? Voluptatibus illum laudantium qui, quis dicta
          temporibus debitis delectus aspernatur. Necessitatibus quo modi
          corporis ullam!
        </p>

        <div classNameName="row">
          <div classNameName="pb-5 col-lg-2 col-sm-12 col-md-6">
            <div classNameName="m-auto p-3 border boxz about__font">
              <h4 classNameName="font-weight-bold text-white text-capitalize roboto">
                2018
              </h4>
              <p classNameName="text-secondary rales">started my journey</p>
            </div>
          </div>
          <div classNameName="pb-5 col-lg-2 col-sm-12 col-md-6">
            <div classNameName="m-auto p-3 border boxz about__font">
              <h4 classNameName="font-weight-bold text-white text-capitalize roboto">
                2019
              </h4>
              <p classNameName="text-secondary rales">
                front-end javascript mastery
              </p>
            </div>
          </div>
          <div classNameName="pb-5 col-lg-2 col-sm-12 col-md-6">
            <div classNameName="m-auto p-3 border boxz border about__font">
              <h4 classNameName="font-weight-bold text-white text-capitalize roboto">
                2020
              </h4>
              <p classNameName="text-secondary rales">
                shared my project to the world
              </p>
            </div>
          </div>
          <div classNameName="pb-5 col-lg-2 col-sm-12 col-md-6">
            <div classNameName="m-auto p-3 border boxz about__font">
              <h4 classNameName="font-weight-bold text-white text-capitalize roboto">
                2022
              </h4>
              <p classNameName="text-secondary rales">started my own platform</p>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default About;
